import { sendAction } from '@/utils/spmUtil';
import { acodeConfig } from '@/config/spmConfig';
import Supporter from '../../utils/supporter.js';
import ShareWechat from '../../utils/share-wechat';
import API from '../api';

// 绑定分享按钮点击
export const bindShareClick = () => {
    const shareButton = document.querySelector('#shareButton')
    shareButton?.addEventListener('click', () => {
        sendAction({
            acode: acodeConfig.shareCLick,
        })
        API.call('show_share')
    })
}

export const initWechatShare = () => {
    // 微信分享内容设置
    if(Supporter.isWeixin) {
        ShareWechat({
            title: document.title,
            desc: document.querySelector('meta[name="description"]').getAttribute('content') || '',
            link: window.location.href,
            imgUrl: window.cfgs.thumbnail && window.cfgs.thumbnail.replace(/^\/\//, 'http://') || 'http://s8.rr.itc.cn/org/wapChange/20161_5_11/b8v0r29602064149596.jpg'
        });
    }
}